// HKT-locked date helpers (per `architecture.md §3` + `DESIGN.md §5.x`).
//
// heshe is HKT-locked; storage is UTC but UI boundaries render in HKT.
// `toHktToday()` returns today's date as an ISO YYYY-MM-DD string in the
// HKT zone, suitable for the wishlist kanban's day-delta footer.

const HKT_OFFSET_MINUTES = 8 * 60;

export function toHktToday(now: Date = new Date()): string {
  // Convert the JS Date (UTC ms) to HKT wall-clock date. We use
  // `Intl.DateTimeFormat` with the `en-CA` locale (which formats as
  // YYYY-MM-DD) and the HKT timeZone, so DST is irrelevant (HKT is fixed).
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: "Asia/Hong_Kong",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).formatToParts(now);
  const year = parts.find((p) => p.type === "year")?.value ?? "1970";
  const month = parts.find((p) => p.type === "month")?.value ?? "01";
  const day = parts.find((p) => p.type === "day")?.value ?? "01";
  return `${year}-${month}-${day}`;
}

export { HKT_OFFSET_MINUTES };
